module.exports = __webpack_public_path__ + "img/banner_450.635de27c.webp";